import { ReactQueryDevtools } from "@tanstack/react-query-devtools"

const DevTools: React.FC = () => {
  if (process.env.NODE_ENV === "development") {
    return <ReactQueryDevtools initialIsOpen={false} />
  }
  return null
}

export default DevTools
